<template>
  <div class="app-sim-card-order">
    <slot name="txtBefore"></slot>
    <b-row class="">
      <b-col class="button">
        <b-button type="button" variant="primary" @click="showModal">
          <slot name="btnLabel"></slot>
        </b-button>
      </b-col>
    </b-row>
    <SimOrderModal
      :show.sync="modalShow"
      :simtype.sync = "simtype_"
      :show-prev="false"
      @next = "activationCall"
      :show-esim="showEsim"
      :modal-title="'Ersatz-SIM bestellen / SIM wechseln'">
      <template v-for="slot in possibleChildSlotsFor('CardOrder')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SimOrderModal>
    <slot name="txtAfter"></slot>
    <MfaHandler @completed="order" @close="closeModal">
      <template v-for="slot in possibleChildSlotsFor('Mfa')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MfaHandler>
  </div>
</template>
<script>

import SimOrderModal from './SimOrderModal.vue'
import slotProxy from '../../../../../../mixins/slotProxy'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { SimTypes } from '@/helper/SimTypes'
import MfaHandler from '@/components/process/generic/Mfa/MfaHandler.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

export default {
  name: 'SimOrder',
  mixins: [
    slotProxy()
  ],
  data () {
    return {
      modalShow: false,
      simtype_: SimTypes.simCardCode,
      productNumber: ''
    }
  },
  components: { MfaHandler, SimOrderModal },
  methods: {
    ...mapActions('mfa', [
      'initiateMfa',
      'fetchMfaInfo'
    ]),
    ...mapMutations('mfa', [
      'resetMfaState',
      'setMsisdn'
    ]),
    showModal: function () {
      this.modalShow = true
    },
    closeModal: function () {
      this.modalShow = false
    },
    ...mapActions('substituteSimCard', [
      'requestSubstituteSimCard'
    ]),
    async activationCall (productNumber) {
      this.productNumber = productNumber

      if (this.isMfaCompleted) {
        this.order(this.productNumber)
        return
      }

      this.setMsisdn(this.currentCustomer?.contract?.msisdn)

      if (this.getToken !== '' && this.getMethod !== '') {
        try {
          await this.fetchMfaInfo()
        } catch (error) {
          this.modalShow = false
        }
      }

      if (this.getToken === '' || this.getMethod === '' || !this.isMfaTokenValid) {
        try {
          await this.requestSubstituteSimCard({
            productNumber: this.productNumber,
            simType: this.simtype_,
            mfaToken: this.getToken
          })
        } catch (error) {
          splitError(error).forEach(e => this.$store.commit('addError', e))
          this.modalShow = false
          return
        }
      }

      if (this.getToken !== '' && this.getMethod !== '') {
        try {
          await this.initiateMfa()
        } catch (error) {
          splitError(error).forEach(e => this.$store.commit('addError', e))
          this.modalShow = false
        }
      }
    },
    order () {
      this.requestSubstituteSimCard({ productNumber: this.productNumber, simType: this.simtype_, mfaToken: this.getToken })

      // Reset the mfa state on success
      this.resetMfaState()
      this.$emit('refresh')
      this.modalShow = false
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('mfa', [
      'getToken',
      'getMethod',
      'isMfaCompleted',
      'isMfaTokenValid'
    ])
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query currentCustomer {
        currentCustomer {
            contract {
              msisdn
            }
          }
      }`, this, 'currentCustomer', {}, null,
      { fetchPolicy: 'cache-first' })
    }
  }
}
</script>
